export default "__VITE_ASSET__a2cc3997__"